module.exports = function(container) {
  if (container) {
    $(container).on('click', 'button.add-to-cart', function() {
      $('.product-detail').data('pid', $(this).data('pid'));
    });
  }
};
